var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "splide" },
    [
      _vm.hasSliderWrapper
        ? _c("div", { staticClass: "splide__slider" }, [
            _c("div", { staticClass: "splide__track" }, [
              _c("ul", { staticClass: "splide__list" }, [_vm._t("default")], 2),
            ]),
          ])
        : _c("div", { staticClass: "splide__track" }, [
            _c("ul", { staticClass: "splide__list" }, [_vm._t("default")], 2),
          ]),
      _vm._v(" "),
      _vm._t("controls"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }